"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _documents = require("../../../utils/documents");

var _DocumentVersion = _interopRequireDefault(require("../documentVersion/DocumentVersion"));

var _arrays = require("../../../utils/arrays");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _DocumentDetailsHeader = _interopRequireDefault(require("./DocumentDetailsHeader"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line
function DocumentDetails(props) {
  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      showTimeline = _React$useState2[0],
      setShowTimeline = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      loadingTimeline = _React$useState4[0],
      setLoadingTimeline = _React$useState4[1];

  var _React$useState5 = _react.default.useState([]),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      timelineVersions = _React$useState6[0],
      setTimelineVersions = _React$useState6[1];

  if ((0, _arrays.isEmpty)(props.documentVersions)) {
    return null;
  }

  var headerDocumentVersion = props.documentVersions.find(function (documentVersion) {
    return documentVersion.overallStatusDocument;
  });

  if (!headerDocumentVersion) {
    // eslint-disable-next-line no-console
    console.error("The correlationId \"".concat(props.documentVersions[0].correlationId, "\" has no version with overallStatusDocument. The render of the document will not be done"));
    return null;
  }

  var invalidVersion = props.documentVersions.find(function (documentVersion) {
    return !_documents.DOCUMENT_STATES_VALID.includes(documentVersion.state);
  });
  var statusValidSignedOrNotApplicable = !!props.documentVersions.find(function (documentVersion) {
    return documentVersion.state === _documents.DOCUMENT_STATE.NOT_APPLICABLE || [_documents.DOCUMENT_STATE.VALID, _documents.DOCUMENT_STATE.SIGNED].includes(documentVersion.state);
  });
  var currentVersion = props.documentVersions.find(function (documentVersion) {
    return _documents.DOCUMENT_STATES_VALID.filter(function (state) {
      return state !== _documents.DOCUMENT_STATE.EXPIRED;
    }).includes(documentVersion.state) && documentVersion.overallStatusDocument;
  });
  var hasCollectionMandateEnabled = props.documentVersions.some(function (documentVersion) {
    return documentVersion.collectionMandateEnabled;
  });
  var showAddNewVersion = (props.documentPermissions.canUpload || props.documentPermissions.canUploadByMandate) && (!hasCollectionMandateEnabled || headerDocumentVersion.type.gatheredByDepositor) && statusValidSignedOrNotApplicable;

  function handleClickAddNewVersion(event) {
    event.preventDefault();
    event.stopPropagation();
    props.documentActions.onAddNewVersion(props.documentVersions[0]);
  }

  function handleShowTimeline() {
    setShowTimeline(true);
    setLoadingTimeline(true);
    props.getTimelineVersionsFn().then(function (response) {
      var versions = response.map((0, _documents.computeHasAnotherOccurrenceInSameDossier)(response));
      setTimelineVersions(versions);
      setLoadingTimeline(false);
    });
  }

  var message = null;

  if (headerDocumentVersion.state === _documents.DOCUMENT_STATE.REJECTED && headerDocumentVersion.rejectionReason) {
    message = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "error inline-container mt-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "error"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.documentDetails.documentIsRejected"
        })
      })]
    });
  } else if (props.documentVersions.some(function (document) {
    return headerDocumentVersion.uid !== document.uid && document.state === _documents.DOCUMENT_STATE.REJECTED;
  })) {
    message = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "error inline-container mt-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "error"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.documentDetails.documentVersionIsRejected"
        })
      })]
    });
  } else if (props.documentVersions.some(function (document) {
    return headerDocumentVersion.uid !== document.uid && document.state === _documents.DOCUMENT_STATE.AWAITING_SIGNATURE;
  })) {
    message = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "error inline-container mt-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "error"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.documentDetails.documentVersionIsAwaitingSignature"
        })
      })]
    });
  }

  var dossiers = props.documentVersions[0].type.dossier === _documents.DOSSIER_TYPE.PROJECT ? props.documentVersions[0].dossiers.filter(function (dossier) {
    return dossier.type === 'PROJECT';
  }) : [];
  var correlationId = props.documentVersions[0].correlationId;
  var isOpen = Boolean(props.correlationIdOpened && correlationId === props.correlationIdOpened);
  var showTimeLineButton = Boolean(props.getTimelineVersionsFn) && (!showTimeline || showTimeline && loadingTimeline);

  var timelineVersionPermissions = _objectSpread(_objectSpread({}, props.documentPermissions), {}, {
    canEditAdditionalDesignation: false,
    canSeeSignAction: false,
    canSign: false,
    canUpload: false,
    canUploadByMandate: false,
    canDuplicate: false,
    canDelete: false
  });

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "document-card".concat(isOpen ? ' open' : ''),
    id: "document-details-".concat(correlationId),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "document-details-header",
      className: "main",
      onClick: function onClick() {
        return props.handleClick(isOpen ? null : correlationId);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentDetailsHeader.default, {
        isOpen: isOpen,
        document: headerDocumentVersion,
        documentPermissions: props.documentPermissions,
        documentActions: props.documentActions,
        message: message,
        showUpdate: !invalidVersion,
        dossiers: dossiers,
        hasCollectionMandateEnabled: hasCollectionMandateEnabled
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
      in: isOpen,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "collapse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("hr", {
          className: "mt-0 mb-4"
        }), hasCollectionMandateEnabled && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex-container space-between mb-4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-container column",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("strong", {
              "data-id": "document-details-gathered-mention",
              className: "inline-container",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "information-primary",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                  icon: "info"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                value: "document.documentDetails.documentIsGathered.".concat(headerDocumentVersion.type.country)
              })]
            })
          })
        }), invalidVersion && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersion.default, {
          document: invalidVersion,
          documentPermissions: props.documentPermissions,
          documentActions: props.documentActions
        }), !showTimeline && currentVersion && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: invalidVersion ? 'mt-4' : '',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersion.default, {
            document: currentVersion,
            documentPermissions: props.documentPermissions,
            documentActions: props.documentActions
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col-12 flex-container space-between mt-4",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: !currentVersion && props.noCurrentVersion
          }), showAddNewVersion && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            "data-id": "document-details-add-new-version",
            type: "button",
            className: "button primary small no-wrap inline-container".concat(!props.documentPermissions.canUpload && props.documentPermissions.canUploadByMandate ? ' bo' : ''),
            onClick: handleClickAddNewVersion,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.documentDetails.addNewVersion"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              icon: "upload"
            })]
          })]
        }), showTimeLineButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          "data-id": "show-timeline-button",
          className: "small secondary flex-container mt-3",
          onClick: handleShowTimeline,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: loadingTimeline ? 'loader' : 'document-page'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.documentDetails.showTimelineButton"
          })]
        }), showTimeline && !loadingTimeline && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "mt-5 mb-5 font-size-l",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.documentDetails.timeline"
            })
          }), (0, _arrays.isEmpty)(timelineVersions) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.documentDetails.emptyTimeline"
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "document-versions",
            children: timelineVersions.sort(_documents.sortWithBestEfforts).map(function (timelineVersion) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersion.default, {
                document: timelineVersion,
                documentPermissions: timelineVersionPermissions,
                documentActions: props.documentActions,
                isCurrent: timelineVersion.uid === (currentVersion === null || currentVersion === void 0 ? void 0 : currentVersion.uid)
              }, "timeline-version-".concat(timelineVersion.uid));
            })
          })]
        })]
      })
    })]
  });
}

DocumentDetails.propTypes = {
  documentVersions: _propTypes.default.arrayOf((0, _documents.documentVersionPropTypes)()).isRequired,
  documentPermissions: (0, _documents.documentPermissionsPropTypes)().isRequired,
  documentActions: (0, _documents.documentActionsPropTypes)().isRequired,
  correlationIdOpened: _propTypes.default.string,
  handleClick: _propTypes.default.func.isRequired,
  onDocumentExampleOpen: _propTypes.default.func,
  getTimelineVersionsFn: _propTypes.default.func,
  noCurrentVersion: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func])
};
var _default = DocumentDetails;
exports.default = _default;
//# sourceMappingURL=DocumentDetails.js.map